export function buildTellentAssistantHeaders(
  token: string | null,
  actor: string | null,
  devPlayground: boolean,
): Record<string, string> {
  const headers: Record<string, string> = {};
  if (devPlayground) {
    headers['x-mastra-dev-playground'] = 'true';
    if (actor) headers['x-ts-actor'] = actor;
  }
  if (token) headers['Authorization'] = token;
  return headers;
}

export const AGENT_ID = 'tellentAssistant';
